import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { AuthKitProvider } from "@workos-inc/authkit-react";
import { BrowserRouter } from "react-router";
import { createRoot } from "react-dom/client";
import Router from "./routes.tsx";
import "./index.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Toaster } from "./components/ui/toaster.tsx";
import { AdminModeProvider } from "./contexts/AdminModeContext";
import { AssistantAvatarProvider } from "./contexts/AssistantAvatarContext";

Sentry.init({
  dsn: "https://4d0836eb28b16b9828bfc99d3efd34cc@o4509204722941952.ingest.de.sentry.io/4509204725956688",
});

console.log("VITE_CLIENT_ID", import.meta.env.VITE_CLIENT_ID);
console.log("VITE_REDIRECT_URI", import.meta.env.VITE_REDIRECT_URI);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthKitProvider
        clientId={import.meta.env.VITE_CLIENT_ID}
        redirectUri={import.meta.env.VITE_REDIRECT_URI}
      >
        <AdminModeProvider>
          <AssistantAvatarProvider>
            <ToastContainer />
            <Toaster />
            <Router />
          </AssistantAvatarProvider>
        </AdminModeProvider>
      </AuthKitProvider>
    </BrowserRouter>
  </StrictMode>,
);
